import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10 3L4.5 8.5L2 6", stroke: "white", strokeWidth: 1.6666, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgWhiteCheck);
export default ForwardRef;
